import { FormTextWrapper } from "../Form";
import { Select, Input, Modal } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const StyledSelectForm = styled(Select)`
  font-weight: 400;
  font-size: 12px;

  .arrow-icon {
    display: flex;
    align-items: center;
  }

  &.ant-select-open .arrow-icon {
    transform: rotate(180deg);
  }

  .ant-select-selection-item {
    color: #007bfb;
  }
`;

export const StyledTextArea = styled(Input.TextArea)`
  &.ant-input {
    line-height: 24px;
  }
`;

export const GlobalModalStyles = createGlobalStyle`

  .ant-modal.add-comment-modal .ant-form > .ant-form-item:last-child {
    margin-top: 24px;
  }
`;

export const StyledFormTextWrapper = styled(FormTextWrapper)`
  font-size: 12px;
  font-weight: 400;

  .ant-form-item-no-colon {
    color: #2b303b !important;
  }
`;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    margin-top: 20%;
    border-radius: 24px;
  }

  .ant-modal-header {
    margin-bottom: 24px;
  }

  .ant-modal-title {
    color: #2b303b !important;
    padding-bottom: 24px;
    border-bottom: 1px solid #eaedf5;
  }

  .ant-form-item {
    display: flex;
    flex-direction: column;
  }

  .ant-form-item-label {
    text-align: start;
  }

  ${StyledFormTextWrapper} {
    margin: inherit auto;
  }

  .ant-col {
    width: 100%;
  }

  .ant-modal-footer {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #eaedf5;
  }

  .ant-btn {
    border-radius: 8px;
  }
`;
